import BubbleCommon, {
  keywordDrillUrlShortcutKeywordTips,
} from '@op/components/BubbleCommon';
import React from 'react';
import { Tag } from 'tea-component';

interface ITagListProps {
  list: Array<{
    text: string;
    value: string;
    textZh: string;
  }>;
  isEn: boolean;
  setValue: (value: string) => void;
}

export default function TagList({ list, isEn, setValue }: ITagListProps) {
  return (
    <div className='dbo-tag-list-wrapper'>
      {list?.map(({ text, value, textZh, valueZh }: any) => {
        const renderText = isEn ? text : textZh;
        const realValue = isEn ? value : valueZh || value;
        return (
          <BubbleCommon
            tipsMap={keywordDrillUrlShortcutKeywordTips(realValue)}
            showIcon={false}
            placement="top"
            key={text}
          >
            <Tag
              onClick={() => setValue(realValue)}
              key={renderText}
              style={{ cursor: 'pointer' }}
            >
              {renderText}
            </Tag>
          </BubbleCommon>
        );
      })}
    </div>
  );
}
